module.exports = __webpack_public_path__ + "static/stl-99d2703ac8cf39becb5af6bf260b647e.png";